import { useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { IoMdClose } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import NodeInstance from "../../../../Global/nodeAxios";
import { setAppError } from "../../../../store/userSlice";
// import nodeinstance from "../../nodeInstance";

export default function FinInsu({ PopUp, setPopUp, url, title, callBack }) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState();
  const [error, setError] = useState(false);

  const submitHandler = async (e, fileData, propData) => {
    console.log("fileData......", fileData, file);
    e.preventDefault();
    const token = localStorage.getItem("nodeToken");
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("file", file);
      const response = await NodeInstance.post(url, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
      if (response.status === 200) {
        dispatch(
          setAppError({
            msg: "Uploaded successfully.",
            color: "success",
          })
        );
        setPopUp(false);
        callBack();
      }
    } catch (err) {
      console.log("error to be seen in console", err);
    }
  };

//   console.log("errors..........", newResponse);
  return (
    <>
      <div
        className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center ${
          PopUp ? "flex" : "hidden"
        }`}
      >
        <div className="max-w-lg w-full h-auto   rounded-md bg-white/95 flex  flex-col p-4 relative">
          <div className="flex justify-between items-center w-full">
            <h1
              className="text-md font-semibold cursor-pointer"
              onClick={() => {
                setPopUp(false);
              }}
            >
              <IoMdClose />
            </h1>
          </div>

          <form onSubmit={(e) => submitHandler(e, file)} className="w-full">
            <div className="w-full flex flex-col gap-3 my-3 p-5">
              <div className="form-control w-full ">
                <label className="label">
                  <span className="label-text">{title}</span>
                </label>
                <input
                  type="file"
                  className="file-input file-input-bordered w-full "
                  onChange={(e) => setFile(e.target.files[0])}
                  required
                  accept="application/xls, application/xlsx"
                />
              </div>
              <div
                className="flex gap-3 w-full justify-center"
                style={{ margin: 2 }}
              >
                <button
                  type="submit"
                  className="p-3 bg-red text-white rounded-md w-full max-w-xs m-2 my-4 flex gap-3 justify-center items-center text-sm" // Decreased padding and font size
                >
                  {" "}
                  <p>Submit</p>
                  {loading ? <CgSpinner className="animate-spin" /> : ""}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
